import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import Loading from '../loading/Loading';
import { labelGrid } from '../utils';
import { Add, Check, CheckCircle, CheckCircleOutline } from '@mui/icons-material';

function CustomTableSelectUsuariosSup(props: {
    data: any[], buscouUsuarios: boolean, handleSetUsuario: (usuario: any) => void, usuarioSelecionado: any | null
}) {
    const rows = props.data;
    const showCollsTable = ['nome', 'email'];
    const StyledTableCell = styled(TableCell)(() => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: '#e9f2fd',
            color: '#0f3550',
            fontSize: '12px',
            letterSpacing: '0.6px',
            padding: '4px 16px',
            marginTop: '-5px',
            borderBottom: '2px solid #d9e5ee',
            position: 'sticky',
            top: 0,
            zIndex: 2,
            whiteSpace: 'nowrap',
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: '12px',
            color: '#334155',
            padding: '5px 16px',
            borderBottom: '1px solid #E2E8F0',
        },
    }));

    const StyledTableRow = styled(TableRow)(() => ({
        height: '32px',
        '&:nth-of-type(odd)': {
            backgroundColor: '#f8fafc',
        },
        '&:hover': {
            backgroundColor: '#eef4fb',
            transition: 'background-color 0.15s ease',
        },
        '&:last-child td, &:last-child th': {
            borderBottom: 0,
        },
    }));

    return (
        <TableContainer
            component={Paper}
            sx={{
                height: '100%',
                maxHeight: 500,
                overflowY: 'auto',
                overflowX: 'auto',
                boxShadow: 'none',
                borderRadius: '4px',
                border: '1px solid #e2e8f0',
            }}
        >
            <Table aria-label="customized table" stickyHeader>
                <TableHead>
                    <TableRow>
                        <StyledTableCell sx={{ width: 250, textAlign: "left !important" }}>{labelGrid.descricao}</StyledTableCell>
                        <StyledTableCell sx={{ width: 80, textAlign: "left !important" }}>{labelGrid.email}</StyledTableCell>
                        <StyledTableCell sx={{ width: 96, textAlign: "center !important" }}>{'Selecionar'}</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows && rows.length > 0 ? (
                        rows.map((row: any, index: number) => {
                            // Lógica de verificação da linha selecionada
                            const isSelected = row.id === props.usuarioSelecionado?.id;

                            return (
                                <StyledTableRow
                                    key={index}
                                    sx={isSelected ? {
                                        backgroundColor: '#e9f2fd !important',
                                        borderLeft: '4px solid #0965c1',
                                        fontWeight: 'bold', // Aplica negrito
                                        '& .MuiTableCell-root': { fontWeight: 'bold' }, // Garante negrito nas células
                                        '&:hover': { backgroundColor: '#ddeafb !important' }
                                    } : {}}
                                >
                                    {showCollsTable.map((col) => (
                                        <TableCell key={col} align="left" sx={{ fontSize: '12px', color: '#334155', padding: '5px 16px', borderBottom: '1px solid #E2E8F0' }}>
                                            {row[col] !== null && row[col] !== undefined && row[col] !== ''
                                                ? row[col]
                                                : <span style={{ color: '#94a3b8', fontSize: '12px' }}>N/D</span>}
                                        </TableCell>
                                    ))}
                                    <TableCell align="center" sx={{ width: 96, padding: '2px 8px', borderBottom: '1px solid #E2E8F0' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, width: '100%' }}>
                                            <Tooltip title="Selecionar">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => props.handleSetUsuario?.(row)}
                                                    sx={{ color: '#0965c1', '&:hover': { color: '#1D4ED8', backgroundColor: 'rgba(37,99,235,0.08)' } }}
                                                >
                                                   {isSelected ? <CheckCircle sx={{ fontSize: '18px' }}  /> : <AddCircleIcon sx={{ fontSize: '17px' }} />}
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </TableCell>
                                </StyledTableRow>
                            );
                        })
                    ) : (
                        <TableRow>
                            <TableCell colSpan={showCollsTable.length + 1} align="center" sx={{ py: 6, borderBottom: 0 }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                    <SearchOffIcon sx={{ fontSize: 36, color: '#94a3b8' }} />
                                    <Typography sx={{ fontSize: '14px', color: '#64748b', fontWeight: 500 }}>
                                        Nenhum usuário encontrado
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px', color: '#94a3b8' }}>
                                        Selecione outra empresa para visualizar os usuários associados
                                    </Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default CustomTableSelectUsuariosSup;
